import { type ISourceOptions } from "@tsparticles/engine";

export const getParticlesOptions = (color: string): ISourceOptions => {
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  return {
    fpsLimit: isMobile ? 30 : 40,
    particles: {
      number: {
        value: isMobile ? 12 : 20,
        density: {
          enable: true,
          width: 800,
          height: 800,
        },
      },
      color: {
        value: color,
      },
      shape: {
        type: "circle",
      },
      opacity: {
        value: 0.7,
      },
      size: {
        value: isMobile ? 1 : 1.4,
      },
      move: {
        enable: true,
        speed: isMobile ? 2 : 3,
        direction: "bottom",
        angle: { value: 90, offset: 0 },
        gravity: {
          enable: false,
          acceleration: 0.2,
          maxSpeed: 10,
        },
        outModes: {
          default: "out",
        },
      },
    },
    interactivity: {
      detectsOn: "window",
      events: {
        onHover: { enable: false },
        onClick: { enable: false },
      },
    },
    detectRetina: !isMobile,
  };
};
